var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{attrs:{"entity-name":_vm.$t('operationRecords'),"model":_vm.model,"use-action":false,"use-default-action":false,"use-select":false,"icon":"mdi-developer-board"}})
}
var staticRenderFns = []

export { render, staticRenderFns }